import { TarteaucitronGlobal } from './tarteaucitron.types';

const SCRIPT_SRC = `${process.env.PUBLIC_URL}/tarteaucitron/tarteaucitron.min.js`;

let loadPromise: Promise<TarteaucitronGlobal> | null = null;

export function loadTarteaucitronScript(): Promise<TarteaucitronGlobal> {
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    if (window.tarteaucitron) {
      resolve(window.tarteaucitron);
      return;
    }

    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.async = true;
    script.onload = () => {
      if (window.tarteaucitron) {
        resolve(window.tarteaucitron);
        return;
      }
      // Drop the cached promise so a later call can retry the load.
      loadPromise = null;
      reject(new Error('tarteaucitron global not found after script load'));
    };
    script.onerror = () => {
      // Drop the cached promise so a later call can retry the load.
      loadPromise = null;
      reject(new Error(`Failed to load tarteaucitron script from ${SCRIPT_SRC}`));
    };

    document.head.appendChild(script);
  });

  return loadPromise;
}
